module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="unit-popup">\n    <tbody>\n        ';
 if (!hideUnitNumbers) { 
__p+='\n        <tr>\n            <td>'+
((__t=( apartmentType ))==null?'':__t)+
'</td>\n            <td>'+
((__t=( unit.get("number") ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        ';
 } 
__p+='\n        <tr>\n            <td>Floor plan</td>\n            <td>'+
((__t=( floorPlan.get("name") ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>Area</td>\n            <td>'+
((__t=( floorPlan.get("sq_ft") ))==null?'':__t)+
'</td>\n        </tr>\n    </tbody>\n</table>\n<a class="view-floor-plan" href="#'+
((__t=( floorPlan.get('slug') + '/' + unit.get('uuid') ))==null?'':__t)+
'">View Floor Plan</a>\n';
}
return __p;
};
